import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import App_bazi from "./App_bazi.jsx";
import App_liuyao from "./App_liuyao.jsx";
import App_zeri from "./App_zeri.jsx";
import App_qimen from "./App_qimen.jsx";
import App_yunying from "./App_yuying.jsx";
import App_zhishiku from "./App_zhishiku.jsx"; // Import new app
import App_jifen from "./App_jifen.jsx"; // Import jifen app
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/*八字子应用 - 独立路由 */}
        <Route path="/bazi/*" element={<App_bazi />} />
        {/* 奇门子应用 - 独立路由 */}
        <Route path="/qimen/*" element={<App_qimen />} />
        {/* 六爻子应用 - 独立路由 */}
        <Route path="/liuyao/*" element={<App_liuyao />} />
        {/* 择日子应用 - 独立路由 */}
        <Route path="/zeri/*" element={<App_zeri />} />    
         {/* 运营子应用 - 独立路由 */}
        <Route path="/yunying/*" element={<App_yunying />} />
        {/* 知识库子应用 - 独立路由 */}
        <Route path="/zhishiku/*" element={<App_zhishiku />} />
        {/* 积分子应用 - 独立路由 */}
        <Route path="/jifen/*" element={<App_jifen />} />
        {/* 主应用 - 默认路由 */}
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
